module.exports = __webpack_public_path__ + "static/media/student_white.4623dea4.svg";